var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "workspace", staticClass: "kp-variant-sifter-workspace" },
    [
      _c(
        "header",
        {
          ref: "vksHeader",
          staticClass: "vks-header",
          class: { "is-pinned": _vm.chromePinned },
          style: _vm.pinnedChromeStyle.header,
        },
        [
          _c(
            "div",
            { staticClass: "vks-header-start" },
            [
              _vm._m(0),
              _c("VariantSifterMenuBar", {
                attrs: { "recent-searches": _vm.recentSearches },
                on: { action: _vm.onMenuAction },
              }),
            ],
            1
          ),
          _vm.searchSession
            ? _c("VariantSifterSessionParamBubbles", {
                attrs: {
                  "search-session": _vm.searchSession,
                  "project-id": _vm.projectId,
                  "phenotypes-in-use": _vm.phenotypesInUse || [],
                  "selected-phenotypes":
                    _vm.associationsState.selectedPhenotypes || [],
                  utils: _vm.utilsBox,
                  "bio-index-host": _vm.bioIndexHostFor("gene"),
                },
                on: {
                  "apply-search": _vm.onSessionParamApply,
                  "remove-phenotype": _vm.onRemoveAssociationPhenotype,
                },
              })
            : _vm._e(),
          _vm.canvasActive
            ? _c("VariantSifterViewportControls", {
                staticClass: "vks-header-controls",
                attrs: {
                  "region-zoom": _vm.regionZoom,
                  "region-zoom-out": _vm.regionZoomOut,
                  "zoom-out-at-limit": _vm.zoomOutAtLimit,
                  "region-view-area": _vm.regionViewArea,
                  "data-table-open": _vm.dataTableOpen,
                  "ai-assistant-open": _vm.aiAssistantOpen,
                  "settings-open": _vm.settingsOpen,
                },
                on: {
                  "update:regionZoom": _vm.onRegionZoomUpdate,
                  "update:regionZoomOut": _vm.onRegionZoomOutUpdate,
                  "zoom-slider-commit": _vm.onRegionZoomSliderCommit,
                  "update:dataTableOpen": function ($event) {
                    _vm.dataTableOpen = $event
                  },
                  "toggle-assistant": function ($event) {
                    _vm.aiAssistantOpen = !_vm.aiAssistantOpen
                  },
                  "toggle-settings": function ($event) {
                    _vm.settingsOpen = !_vm.settingsOpen
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.chromePinned,
            expression: "chromePinned",
          },
        ],
        staticClass: "vks-header-spacer",
        style: { height: `${_vm.headerHeightPx}px` },
        attrs: { "aria-hidden": "true" },
      }),
      _vm.canvasActive
        ? _c("VariantSifterWorkspaceGuide", {
            attrs: { open: _vm.workspaceGuideOpen },
            on: {
              close: function ($event) {
                _vm.workspaceGuideOpen = false
              },
            },
          })
        : _vm._e(),
      _c("input", {
        ref: "sessionImportInput",
        staticClass: "vks-session-import-input",
        attrs: { type: "file", accept: ".json,application/json" },
        on: { change: _vm.onSessionFileSelected },
      }),
      _c("div", { staticClass: "vks-main" }, [
        _c(
          "div",
          { staticClass: "vks-stage" },
          [
            _c("VariantSifterCanvas", {
              attrs: {
                sections: _vm.sections,
                "visible-section-ids": _vm.visibleSectionIds,
                "canvas-active": _vm.canvasActive,
                "welcome-open": _vm.welcomeOpen,
                phenotypes: _vm.phenotypes,
                utils: _vm.utilsBox,
                "welcome-initial-values": _vm.welcomeInitialValues,
                "project-id": _vm.projectId,
                "gene-lookup-bio-index-host": _vm.bioIndexHostFor("gene"),
                "tissue-regions-host": _vm.bioIndexHostFor("tissue-regions"),
                "search-session": _vm.searchSession,
                "region-zoom": _vm.regionZoom,
                "region-shift-bp": _vm.regionShiftBp,
                "region-view-area": _vm.regionViewArea,
                "view-region": _vm.viewRegion,
                "data-table-open": _vm.dataTableOpen,
                "mapping-state": _vm.mappingState,
                "workspace-mapping-filter": _vm.workspaceMappingFilter,
                "associations-state": _vm.associationsState,
                "genes-state": _vm.genesState,
                "plot-overlays-state": _vm.plotOverlaysState,
                "plot-markers": _vm.plotMarkersState,
                "credible-sets-state": _vm.credibleSetsState,
                "credible-set-colors": _vm.credibleSetDotColors,
                "credible-set-pill-colors": _vm.credibleSetPillColors,
                "global-enrichment-state": _vm.globalEnrichmentState,
                "v2g-state": _vm.v2gState,
                "s2g-state": _vm.s2gState,
                "region-load-progress-active": _vm.regionLoadProgress.active,
              },
              on: {
                "update:regionShiftBp": _vm.onRegionShiftBpUpdate,
                "update:regionViewArea": _vm.onRegionViewAreaUpdate,
                "pan-end": _vm.onRegionPanEnd,
                "toggle-position-marker": _vm.onTogglePositionMarker,
                "toggle-star-variant": _vm.onToggleStarVariant,
                "set-reference-variant": _vm.onSetReferenceVariant,
                "update:associationsFiltersIndex":
                  _vm.onAssociationsFiltersIndexUpdate,
                "update:geSelectedBiosamples": _vm.onGeSelectedBiosamplesUpdate,
                "update:geActiveAnnotation": _vm.onGeActiveAnnotationUpdate,
                "update:geSelectedTissues": _vm.onGeSelectedTissuesUpdate,
                "update:geSelectedAnnotations":
                  _vm.onGeSelectedAnnotationsUpdate,
                "select-ge-plot-tissue": _vm.onSelectGePlotTissue,
                "update:geBiosampleFilterOptions":
                  _vm.onGeBiosampleFilterOptionsUpdate,
                "update:geBiosampleTissueRegions":
                  _vm.onGeBiosampleTissueRegionsUpdate,
                "update:geBiosampleLoading": _vm.onGeBiosampleLoadingUpdate,
                "update:mappingState": _vm.onMappingStateUpdate,
                "update:workspaceFilterActive":
                  _vm.onWorkspaceFilterActiveUpdate,
                "update:v2gSelectedLinks": _vm.onV2gSelectedLinksUpdate,
                "update:s2gSelectedLinks": _vm.onS2gSelectedLinksUpdate,
                "add-credible-set": _vm.onAddCredibleSet,
                "remove-credible-set": _vm.onRemoveCredibleSet,
                "remove-mapping-category": _vm.onRemoveMappingCategory,
                "close-data-table": function ($event) {
                  _vm.dataTableOpen = false
                },
                "start-search": _vm.onStartSearch,
                "import-session": _vm.openSessionImport,
              },
            }),
            _c("VariantSifterAiAssistantPanel", {
              attrs: {
                open: _vm.aiAssistantOpen,
                "active-tab": _vm.assistantState.activeTab,
                "thread-entries": _vm.assistantState.threadEntries,
                executing: _vm.assistantState.executing,
                "execution-progress-label":
                  _vm.assistantState.executionProgressLabel,
                "llm-available": _vm.assistantState.llmAvailable,
                "can-run-actions": _vm.assistantCanRunActions,
                plan: _vm.assistantState.plan,
                "step-states": _vm.assistantState.stepStates,
                "cs2ct-star-prompt": _vm.assistantState.cs2ctStarPrompt,
                "understudied-star-prompt":
                  _vm.assistantState.understudiedStarPrompt,
                "panel-style": _vm.assistantPanelStyle,
              },
              on: {
                close: function ($event) {
                  _vm.aiAssistantOpen = false
                },
                "update:activeTab": _vm.onAssistantActiveTabUpdate,
                "execute-all": _vm.onAssistantExecuteAll,
                "execute-step": _vm.onAssistantExecuteStep,
                "plan-request": _vm.onAssistantPlanRequest,
                "execute-catalog-action": _vm.onExecuteCatalogAction,
                "confirm-cs2ct-star": _vm.onConfirmCs2ctStar,
                "dismiss-cs2ct-star": _vm.onDismissCs2ctStar,
                "confirm-understudied-star": _vm.onConfirmUnderstudiedStar,
                "dismiss-understudied-star": _vm.onDismissUnderstudiedStar,
                "open-correlated-phenotype": _vm.onOpenCorrelatedPhenotype,
              },
            }),
          ],
          1
        ),
        _vm.canvasActive
          ? _c(
              "div",
              { staticClass: "vks-drawer-rail-slot" },
              [
                _c("VariantSifterSectionDrawers", {
                  attrs: {
                    sections: _vm.visibleSections,
                    "open-drawer-id": _vm.openDrawerId,
                    "search-session": _vm.searchSession,
                    "project-id": _vm.projectId,
                    "associations-state": _vm.associationsState,
                    "plot-overlays-state": _vm.plotOverlaysState,
                    "plot-markers": _vm.plotMarkersState,
                    "credible-sets-state": _vm.credibleSetsState,
                    "credible-set-pill-colors": _vm.credibleSetPillColors,
                    "genes-state": _vm.genesState,
                    "global-enrichment-state": _vm.globalEnrichmentState,
                    "v2g-state": _vm.v2gState,
                    "s2g-state": _vm.s2gState,
                    "mapping-state": _vm.mappingState,
                    "workspace-mapping-filter": _vm.workspaceMappingFilter,
                    "view-region": _vm.viewRegion,
                    utils: _vm.utilsBox,
                    "region-load-progress-active":
                      _vm.regionLoadProgress.active,
                    "rail-pinned": _vm.chromePinned,
                    "rail-pin-style": _vm.pinnedChromeStyle.drawer,
                  },
                  on: {
                    "toggle-drawer": _vm.onToggleDrawer,
                    "update:associationsFiltersIndex":
                      _vm.onAssociationsFiltersIndexUpdate,
                    "toggle-star-variant": _vm.onToggleStarVariant,
                    "set-reference-variant": _vm.onSetReferenceVariant,
                    "toggle-association-ancestry":
                      _vm.onToggleAssociationAncestry,
                    "add-credible-set": _vm.onAddCredibleSet,
                    "remove-credible-set": _vm.onRemoveCredibleSet,
                    "update:credibleSetsPanelFilters":
                      _vm.onCredibleSetsPanelFiltersUpdate,
                    "update:genesSelectedTypes": _vm.onGenesSelectedTypesUpdate,
                    "update:geEnabledMutedAnnotations":
                      _vm.onGeEnabledMutedAnnotationsUpdate,
                    "update:geEnabledMutedAnnotationTissues":
                      _vm.onGeEnabledMutedAnnotationTissuesUpdate,
                    "update:geDisabledAnnotationTissues":
                      _vm.onGeDisabledAnnotationTissuesUpdate,
                    "update:geSelectedAnnotations":
                      _vm.onGeSelectedAnnotationsUpdate,
                    "update:geTissueTrackSort": _vm.onGeTissueTrackSortUpdate,
                    "update:geTrackPValueMax": _vm.onGeTrackPValueMaxUpdate,
                    "update:geSelectedMethods": _vm.onGeSelectedMethodsUpdate,
                    "update:geSelectedSources": _vm.onGeSelectedSourcesUpdate,
                    "update:mappingState": _vm.onMappingStateUpdate,
                    "update:workspaceFilterActive":
                      _vm.onWorkspaceFilterActiveUpdate,
                    "remove-mapping-category": _vm.onRemoveMappingCategory,
                    "update:v2gSelectedTissues": _vm.onV2gSelectedTissuesUpdate,
                    "update:v2gDeselectedMethods":
                      _vm.onV2gDeselectedMethodsUpdate,
                    "update:v2gDeselectedGenes": _vm.onV2gDeselectedGenesUpdate,
                    "update:v2gDeselectedTissues":
                      _vm.onV2gDeselectedTissuesUpdate,
                    "update:v2gDeselectedBiosamples":
                      _vm.onV2gDeselectedBiosamplesUpdate,
                    "update:v2gSelectedLinks": _vm.onV2gSelectedLinksUpdate,
                    "update:v2gViewMode": _vm.onV2gViewModeUpdate,
                    "load-s2g": _vm.onS2gLoad,
                    "clear-s2g": _vm.onS2gClear,
                    "update:s2gDeselectedMethods":
                      _vm.onS2gDeselectedMethodsUpdate,
                    "update:s2gDeselectedGenes": _vm.onS2gDeselectedGenesUpdate,
                    "update:s2gSelectedLinks": _vm.onS2gSelectedLinksUpdate,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("VariantSifterRegionLoadBubble", {
        attrs: { progress: _vm.regionLoadProgress },
        on: { dismiss: _vm.dismissRegionLoadProgress },
      }),
      _c("VariantSifterExportSessionModal", {
        attrs: {
          open: _vm.exportSessionOpen,
          "default-filename": _vm.exportSessionDefaultFilename,
          summary: _vm.exportSessionSummary,
          exporting: _vm.exportSessionBusy,
        },
        on: {
          close: function ($event) {
            _vm.exportSessionOpen = false
          },
          export: _vm.onExportSessionConfirm,
        },
      }),
      _c("VariantSifterSettingsPanel", {
        attrs: {
          open: _vm.settingsOpen,
          sections: _vm.sections,
          "visible-section-ids": _vm.visibleSectionIds,
          "search-session": _vm.searchSession,
          "bio-index-host": _vm.bioIndexHost,
          "default-bio-index-host": _vm.defaultBioIndexHost,
          "project-id": _vm.projectId,
          "resolve-host-for-index": _vm.bioIndexHostFor,
          "suggest-actions-after-user-action":
            _vm.suggestActionsAfterUserAction,
          "refetch-associations-on-zoom": _vm.refetchAssociationsOnZoom,
        },
        on: {
          close: function ($event) {
            _vm.settingsOpen = false
          },
          "update:visibleSectionIds": _vm.onVisibleSectionIdsUpdate,
          "update:projectId": _vm.onProjectIdUpdate,
          "update:suggestActionsAfterUserAction":
            _vm.onSuggestActionsAfterUserActionUpdate,
          "update:refetchAssociationsOnZoom":
            _vm.onRefetchAssociationsOnZoomUpdate,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "vks-brand" }, [
      _c("span", { staticClass: "vks-mark" }, [_vm._v("KP")]),
      _c("span", { staticClass: "vks-title" }, [_vm._v("Variant Sifter")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }